import { render, staticRenderFns } from "./AssignReportUser.vue?vue&type=template&id=b3cf7430"
import script from "./AssignReportUser.vue?vue&type=script&lang=js"
export * from "./AssignReportUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports